// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"a62d977d","672":"79596f23"}[chunkId] + ".chunk.css";
};